module.exports = __webpack_public_path__ + "assets/49ce6a3b31812e62241ee35818f483ad.svg";